import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DatePicker, Popconfirm } from "antd";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { finish } from "actions/scooter/trip-active/actions";

const FinishTripModal = ({
                           id,
                           finish,
                           callback,
                           onCancel
                         }) => {
  const FORMAT = "YYYY-MM-DD HH:mm";

  const [withDate, setWithDate] = useState(false);
  const [date, setDate] = useState(null);
  const [dateError, setDateError] = useState("");

  const handleFinish = () => {
    if (withDate && date === null) {
      setDateError("Please select date or disable `With Date` field");
      return;
    }
    if (withDate && date) {
      finish(id, moment(date).valueOf());
    } else {
      finish(id);
    }
    callback();
  };

  return (
    <div>
      <div>
        <div className="form-check mt-3">
          <input
            className="form-check-input"
            type="checkbox"
            value={Number(withDate)}
            onChange={() => setWithDate(!withDate)}
            id="with-date"
            checked={withDate}
          />
          <label
            className="form-check-label"
            htmlFor="with-date">With Date</label>
        </div>

        <div className="mt-3 mb-4">
          <DatePicker
            value={date
              ? moment(date)
              : null}
            format={FORMAT}
            onChange={(date) => {
              setDate(date ? moment(date)
                .format(FORMAT) : null);
            }}
            className="d-block"
            placeholder="Not set"
            disabled={!withDate}
            disabledDate={(current) => current && current < moment()}
            showTime={{
              format: "HH:mm",
              defaultValue: moment("00:00:00", "HH:mm"),
              minuteStep: 5
            }}
          />
          {dateError && <div className="text-danger">{dateError}</div>}
        </div>

        <div className="d-flex justify-content-between">
          <button className="btn btn-sm btn-danger" onClick={onCancel}>Cancel</button>

          <Popconfirm
            title="Are you sure you want to finish this trip?"
            onConfirm={() => handleFinish()}
            placement="top"
            okText="Yes"
            cancelText="Cancel"
          >
            <button
              className="btn btn-sm btn-warning"
              title="Finish"
            >
              <FontAwesomeIcon icon={faCheckSquare}/> Finish
            </button>
          </Popconfirm>
        </div>
      </div>
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  finish: bindActionCreators(finish, dispatch),
});

export default connect(null, mapStateToDispatch)(FinishTripModal);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/trip-active/finish-trip-modal.js